import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== "production") console.error("UI crash:", error, info);
  }
  reset = () => this.setState({ error: null });
  render() {
    if (this.state.error) {
      return (
        <div className="p-8">
          <div className="max-w-lg mx-auto bg-white border border-rose-200 rounded-2xl shadow-soft p-6 text-center">
            <div className="text-4xl mb-2">⚠️</div>
            <h2 className="font-display text-2xl text-forest-deep">Възникна грешка в този екран</h2>
            <p className="text-sm text-muted-foreground mt-2 break-words">{String(this.state.error?.message || this.state.error)}</p>
            <button onClick={this.reset} className="mt-4 px-5 py-2 rounded-xl bg-forest text-white" data-testid="error-retry">
              Опитай отново
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
